import { getController } from '@/controllers/request';
import { MODULE } from '@/utils/constants';

export default {
  namespaced: true,
  state: {
    vacancyFiltersLoaded: false,
    respondsFiltersLoaded: false,
    filterConfig: {},
    sortConfig: {},
    sortValues: {},
    customFilters: {},
    intents: {},
    filterAdditionalUrl: {},
    filterPopupMetaData: {},
    sortPopupMetaData: {},
    dynamicMultiEnumCache: {
      vacancy_candidates: {},
      attach: {}
    },
    filtersActive: false,
    sortActive: false,
    iteration: 0,
    query: false
  },
  mutations: {
    setFiltersConfig(state, config) {
      state.filterConfig = config;
      state.iteration++;
      //проверка на наличие примененных фильтров
      if (
        (config.hasOwnProperty('checkIndication') && config.checkIndication) ||
        !config.hasOwnProperty('checkIndication')
      ) {
        //в примененном шаблоне
        if (config?.savedSearchData && config?.savedSearchData?.selected) {
          state.filtersActive = true;
          return;
        }
        if (config?.custom_filters) {
          //в кастомных фильтрах
          for (let filter of Object.keys(config.custom_filters)) {
            if (
              config.custom_filters[filter].value != null &&
              config.custom_filters[filter].value != false
            ) {
              state.filtersActive = true;
              return;
            }
          }
        }
        //в основных фильтрах
        if (config?.filters) {
          //в кастомных фильтрах
          for (let filter of Object.keys(config.filters)) {
            if (
              Boolean(config.filters[filter].value) &&
              config.filters[filter].value != null &&
              config.filters[filter].value != false
            ) {
              if (
                config.filters['date_entered_advanced_range_choice'] ||
                config.filters['date_modified_advanced_range_choice']
              )
                return;
              state.filtersActive = true;
              return;
            }
          }
        }
        state.filtersActive = false;
      }
    },
    setFilterAddUrl(state, { module, url, deleteUrl }) {
      if (deleteUrl) {
        state.filterAdditionalUrl = {};
      } else {
        state.filterAdditionalUrl[module] = url;
      }
    },
    setIntents(state, intents) {
      state.intents = intents;
    },
    setFilterPopupMetaData(state, metaData) {
      state.filterPopupMetaData = metaData;
    },
    setPopupMetaDataFiltersRows(state, rows) {
      if (!state.filterPopupMetaData || !state.filterPopupMetaData?.panels[0])
        return;
      state.filterPopupMetaData.panels[0].rows = rows;
    },
    setCustomFilter(state, { filter, val }) {
      state.customFilters[filter] = val;
    },
    resetCustomFilters(state) {
      for (let key in state.customFilters) {
        state.customFilters[key] = '0';
      }
    },
    setFiltersActive(state, value) {
      state.filtersActive = value;
    },
    setSortActive(state, value) {
      state.sortActive = value;
    },
    setIteration(state) {
      state.iteration++;
    },
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setSortValues(state, { moduleName, values }) {
      if (!moduleName) {
        return;
      }
      state.sortValues[moduleName] = values;
    },
    setDynamicMultienumFieldProps(
      state,
      { module, fieldName, propName, propValue }
    ) {
      if (!state.dynamicMultiEnumCache[module][fieldName]) {
        state.dynamicMultiEnumCache[module][fieldName] = {};
      }
      state.dynamicMultiEnumCache[module][fieldName][propName] = propValue;
    },
    clearFilters(state) {
      state.filtersActive = false;
      state.vacancyFiltersLoaded = false;
      state.filterConfig = {};
      state.filterPopupMetaData = {};
    }
  },
  actions: {
    async getFilterData({ state, commit }) {
      let intents = state.intents;
      const moduleToFilter = intents.request.url
        .split('?')[1]
        .split('&')[0]
        .split('=')[1];
      const filterAppliedParam =
        moduleToFilter == MODULE.VACANCY_MODULE
          ? 'vacancyFiltersLoaded'
          : moduleToFilter == MODULE.CANDIDATE_RESPONDS
          ? 'respondsFiltersLoaded'
          : null;

      try {
        const resp = await getController({
          url: intents.request.url,
          params: intents.request.request_params || {}
        });
        commit('setFilterPopupMetaData', resp.data);
        if (filterAppliedParam) {
          commit('setParam', { name: filterAppliedParam, val: true });
        }

        return resp;
      } catch (err) {
        console.error('Ошибка при получении данных для фильтров', err);
      }
    },
    async getSortData({ state, commit }) {
      let intents = state.intents;

      try {
        const resp = await getController({
          url: intents.request.url,
          params: intents.request.request_params || {}
        });
        commit('setParam', { name: 'sortPopupMetaData', val: resp.data });

        return resp;
      } catch (err) {
        console.error('Ошибка при получении данных для сортировки', err);
      }
    }
  }
};
